const positiveId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;

export const getTVSession = () => {
    // Use the same session for the auth guard, identity and feed request.
    for (const key of ['tldata', 'centerdata']) {
        try {
            const saved = localStorage.getItem(key);
            if (!saved) continue;
            const session = JSON.parse(saved);
            if (key === 'tldata' && session?.login_type === 'tl'
                && positiveId(session.center_mis_id) && positiveId(session.centerid)) return session;
            if (key === 'centerdata' && session?.login_type === 'center'
                && positiveId(session.center_id)) return session;
            return null;
        } catch (error) {
            // A malformed saved session must never produce an unscoped request.
            return null;
        }
    }
    return null;
};

export const getTVScope = session => session ? {
    login_type: session.login_type,
    center_id: Number(session.login_type === 'tl' ? session.centerid : session.center_id),
    tl_id: session.login_type === 'tl' ? Number(session.center_mis_id) : 0,
} : null;
